module.exports = __webpack_public_path__ + "img/calculator_bg.c47f9b34.png";